import gql from 'graphql-tag';
import moment from 'moment';
import orderFragment from '../../fragments/order/orderInfo';
export const getOrdersQuery = gql`
  query getOrders(
    $limit: Int
    $offset: Int
    $startDate: String
    $endDate: String
    $filter: Int
    $documentType: ID
  ) {
    orders(
      limit: $limit
      offset: $offset
      startDate: $startDate
      endDate: $endDate
      filter: $filter
      documentType: $documentType
    ) {
      nodes {
        ...orderInfo
      }
      totalCount
      documentSummary {
        totalValue
        grossTotalValue
        documentTypes {
          id
          code
          name
          value
          grossValue
        }
      }
    }
  }
  ${orderFragment}
`;
export const getOrdersQueryOptions = variables => ({
  variables: {
    limit: 30,
    startDate: variables.startDate ? moment(variables.startDate).format('YYYY-MM-DD') : null,
    endDate: variables.endDate ? moment(variables.endDate).format('YYYY-MM-DD') : null,
    filter: variables.filter,
    documentType: variables.documentType
  },
  fetchPolicy: 'network-only',
  notifyOnNetworkStatusChange: true
});
export const getOrdersFetchMore = fetchMore => offset => {
  fetchMore({
    variables: {
      offset
    },
    updateQuery: (prev, {
      fetchMoreResult
    }) => {
      if (!fetchMoreResult) return prev;
      return Object.assign({}, prev, {
        ...fetchMoreResult,
        orders: {
          ...fetchMoreResult.orders,
          documentSummary: fetchMoreResult.orders.documentSummary || prev.orders.documentSummary,
          nodes: [...prev.orders.nodes, ...fetchMoreResult.orders.nodes]
        }
      });
    }
  });
};